import { createFileRoute } from "@tanstack/react-router";
import { AssistWorkspacePage } from "@/modules/avizo-assist/presentation/pages/AssistWorkspacePage";

export const Route = createFileRoute("/_authenticated/assist")({
  component: AssistWorkspacePage,
});
